import { DEFAULT_CHART_COLORS } from '../../../config/chartColors'
import {
  CompanySettingsActionTypes,
  SET_COMPANY_SETTINGS,
  SET_COMPANY_CHART_COLORS,
  DELETE_COMPANY_CHART_COLORS
} from './types'

const initialState = {
  chartColors: DEFAULT_CHART_COLORS
}

const companySettingsReducer = (state = initialState, action: CompanySettingsActionTypes) => {
  switch (action.type) {
    case SET_COMPANY_SETTINGS:
      return { ...state, ...action.payload }
    case SET_COMPANY_CHART_COLORS:
      return { ...state, chartColors: [...action.payload] }
    case DELETE_COMPANY_CHART_COLORS:
      return { ...state, chartColors: [...action.payload] }
    default:
      return state
  }
}

export default companySettingsReducer
